<div class="event-list-item" [class.group]="eventItem()?.isGroup">
  @if (eventItem()?.isGroup) {
    <div class="event-list-item__group-image">
      <img
        class="event-list-item__group-image__logo"
        height="70"
        width="50"
        [alt]="(eventItem()?.team1Name || 'Team') + ' logo'"
        [ngSrc]="'img/istra/logo.svg'"
      />
      <p class="event-list-item__group-image__text">2025/2026</p>
    </div>
  } @else {
    <img
      class="event-list-item__image"
      height="62"
      width="45"
      [alt]="(eventItem()?.team1Name || 'Team') + ' logo'"
      [ngSrc]="'img/logo-klubova/' + eventItem()?.team1Logo"
    />
    <div class="event-list-item__dashes"></div>
    <img
      class="event-list-item__image"
      height="62"
      width="45"
      [alt]="(eventItem()?.team2Name || 'Team') + ' logo'"
      [ngSrc]="'img/logo-klubova/' + eventItem()?.team2Logo"
    />
  }
  <div class="event-list-item__details">
    <p class="event-list-item__details__title">{{ eventItem()?.eventName }}</p>
    <p class="event-list-item__details__time">{{ eventItem()?.startTime | date:'dd. MMMM yyyy. - HH:mm' | titlecase }}</p>
    @if (eventItem()?.isGroup) {
      <button type="button" class="btn btn-secondary" (click)="handleClick()">{{'COMMON.BUY_GROUP_TICKET' | translate}}</button>
    }
  </div>
  @if (!eventItem()?.isGroup) {
    <!--<div class="event-list-item__separator"></div>-->
    <button type="button" class="btn btn-primary" (click)="handleClick()">{{'COMMON.TICKETS' | translate}}</button>
  }

</div>
